import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cm_active",
  "use": "icon-cm_active-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cm_active\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h1024v1024H0V0z m731.428571 219.428571a219.428571 219.428571 0 1 1-438.857142 0V146.285714H146.285714v73.142857a365.714286 365.714286 0 0 0 731.428572 0V146.285714h-146.285715v73.142857z\" p-id=\"8780\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cm_active.svg
// module id = WEWW
// module chunks = 16